module.exports = __webpack_public_path__ + "img/gb9116_19_c.prt.eb601174.jpg";